import {
	Notify,
	Icon,
	ActionSheet,
	Tab,
	Tabs,
	List,
	Cell,
	CellGroup,
	Picker,
	DatetimePicker,
	Popup,
	Uploader,
	Badge,
	Form,
	Button,
	Radio,
	RadioGroup,
	Empty,
	Dialog,
	Field,
	Checkbox,
	Popover,
	Toast,
	PasswordInput,
	NumberKeyboard,
	CountDown,
	Overlay,
	Tabbar,
	TabbarItem,
	Col,
	Row,
	Grid,
	GridItem,
	Switch,
	Cascader,
	Image,
	ShareSheet
} from 'vant'

Toast.setDefaultOptions({ duration: 3000 })
const components = [
	Notify,
	Icon,
	ActionSheet,
	Tab,
	Tabs,
	List,
	Cell,
	CellGroup,
	Picker,
	DatetimePicker,
	Popup,
	Uploader,
	Badge,
	Form,
	Button,
	Radio,
	RadioGroup,
	Empty,
	Dialog,
	Field,
	Checkbox,
	Popover,
	Toast,
	PasswordInput,
	NumberKeyboard,
	CountDown,
	Overlay,
	Tabbar,
	TabbarItem,
	Col,
	Row,
	Grid,
	GridItem,
	Switch,
	Cascader,
	Image,
	ShareSheet
]

export default Vue => components.forEach(item => Vue.use(item))
